import React from 'react';
import { useQuery } from '@apollo/client';
import ActivityList from '../activities/ActivityList';
import useFetchMoreActivities, {
  ALL_TOPIC_ACTIVITIES_TYPES,
  nextBeforeAt,
} from '../activities/useFetchMoreActivities';
import RightPanel from '../app/layout/RightPanel';
import EmptyState from '../components/EmptyState';
import { gql } from '../graphql/generated/gql';
import CreatePostButton from '../post/CreatePostButton';
import useSlug from '../utils/router/useSlug';
import * as styles from './TopicActivitiesPanel.module.scss';

const TOPIC_ACTIVITIES_QUERY = gql(/** @complexity 14 */ `
  query topicActivities($id: ID!, $beforeAt: Datetime!, $actions: [TopicActivityAction!]) {
    topicActivities(beforeAt: $beforeAt, topicIds: [$id], actions: $actions) {
      ...ActivityList_activities
    }
  }
`);

const TopicActivitiesPanel = () => {
  const [topicId] = useSlug('topicSlug');
  const response = useQuery(TOPIC_ACTIVITIES_QUERY, {
    variables: {
      id: topicId,
      beforeAt: nextBeforeAt(),
      actions: ALL_TOPIC_ACTIVITIES_TYPES,
    },
  });

  const activities = response.data?.topicActivities;
  const fetchMoreActivities = useFetchMoreActivities(
    response,
    'topicActivities',
  );

  return (
    <RightPanel.Inner header={<RightPanel.Header title="Activity" />}>
      <div className={styles.content}>
        {activities?.length ? (
          <ActivityList
            activities={activities}
            fetchMore={fetchMoreActivities}
          />
        ) : (
          <EmptyState
            title="No activity yet…"
            message="Activity will appear after a post has been created under this topic."
            action={
              <CreatePostButton
                size="large"
                variant="secondary"
                topicId={topicId}
              >
                Create a post
              </CreatePostButton>
            }
            vertical
          />
        )}
      </div>
    </RightPanel.Inner>
  );
};

export default TopicActivitiesPanel;
